import React, { Component } from "react";
import { FormControl } from "react-bootstrap";
import TimeStamp from "react-timestamp";
import NotificationSystem from "react-notification-system";
import _ from "lodash";
import { ClipLoader } from "react-spinners";
// No data found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

import accountManagement from "../../assets/img/AccountManagement.png";
import lockAccess from "../../assets/img/LockAccess.png";
import loginRequest from "../../assets/img/LoginRequest.png";

import unknownStatus from "../../assets/img/UnknownStatus.png";
import deleteLocks from "../../assets/img/deleteLock.png";
import userPasswordChange from "../../assets/img/changeUserPassword2.png";
import lockPasswordChange from "../../assets/img/lockPasswordChange.png";
import changeLockPasswords from "../../assets/img/changeLockPassword6.png";
import updateEmail from "../../assets/img/updateEmail.png";
import updateEmail2 from "../../assets/img/updateEmailTest.png";

import memberRemovedIcon from "../../assets/img/memberRemovedIcon.png";
import memberGroupMemberAddedIcon from "../../assets/img/memberGroupMemberAddedIcon.png";
import memberGroupCreatedIcon from "../../assets/img/memberGroupCreatedIcon.png";
import memberGroupDeletedIcon from "../../assets/img/memberGroupDeletedIcon.png";
import memberGroupEditedIcon from "../../assets/img/memberGroupEditedIcon.png";
import memberGroupMemberRemovedIcon from "../../assets/img/memberGroupMemberRemovedIcon.png";
import memberBulkRemovedIcon from "../../assets/img/memberBulkRemovedIcon.png";

import SystemsUpdate from "../../assets/img/SystemsUpdate.png";

// import changeLockPasswords1 from '../../assets/img/changeLockPassword1.png';
// import changeLockPasswords2 from '../../assets/img/changeLockPassword2.png';
// import changeLockPassword5 from '../../assets/img/changeLockPassword5.png';

import notificationStatus from "../../assets/img/notificationStatus.png";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";
import "../../routes/app";

import ApprovalBtn from "./ApprovalBtn";

import LocalizedStrings from "react-localization";
import { style } from "variables/Variables.jsx";
let localizationStrings = new LocalizedStrings({
  en: {
    deviceUIDTitle: "Device ID",
    deviceTitle: "Device type",
    timeTitle: "Time",
    statusTitle: "Approval status",
    tokenTitle: "Request token",
    userEmailTitle: "Email",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    noDataTitle: "There is no data to display",
    refreshTitle: "Refresh",
    deletedLock: "Deleted Lock",
    changedPassword: "The account password has been changed",
    changedEmail: "The account email has been updated",
    deletedMessage: " You have deleted the Lock: ",
    lockChangedPassword: "Lock Password Update",
    hasBeenDeleted: "has been deleted",
    lockPasswordBeenChanged: " password has been changed",
    from: "From ",
    to: " to ",
    by: " by ",
    memberRemoveditle: "Member Removed",
    memberRemovedDescription: " has been removed successfully.",
    memberGroupMemberAddTitle: "Member Group's Member Added",
    memberGroupMemberAddDesc: "Member(s) had been added to member group",
    memberGroupMemberRemovedTitle: "Member Group's Member Removed",
    memberGroupMemberRemovedDesc:
      "Member(s) had been removed from member group",
    memberGroupCreatedTitle: "Member Group's Created",
    memberGroupCreatedDesc: "member group had been created",
    memberGroupDeletedTitle: "Member Group's Deleted",
    memberGroupDeletedDesc: "member group had been Deleted",
    memberGroupEditTitle: "Member Group's Details Changed",
    memberGroupEditDesc: "member group details had been modified",
  },
  ja: {
    deviceUIDTitle: "デバイスID",
    deviceTitle: "デバイスタイプ",
    timeTitle: "時間",
    statusTitle: "承認状況",
    refreshTitle: "リフレッシュ",
    tokenTitle: "リクエストトークン",
    userEmailTitle: "メール",
    resultTitle1: "表示中 ",
    resultTitle2: " に ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    noDataTitle: "表示するデータがありません。",
    deletedLock: "スマートロック登録削除",
    lockChangedPassword: "スマートロック解錠パスワード更新",
    changedPassword: "登録パスワードが変更されました",
    changedEmail: "アカウントのメールが更新されました",
    deletedMessage: " ロックを削除しました: ",
    lockPasswordBeenChanged: "パスワードが変更されました",
    hasBeenDeleted: "削除されました",
    from: "から ",
    to: " まで ",
    by: " by ",
    memberRemoveditle: "メンバー削除",
    memberRemovedDescription: " が正常に削除されました。",
    memberGroupMemberAddTitle: "Member Group's Member Added",
    memberGroupMemberAddDesc: "Member(s) had been added to member group",
    memberGroupMemberRemovedTitle: "Member Group's Member Removed",
    memberGroupMemberRemovedDesc:
      "Member(s) had been removed from member group",
    memberGroupCreatedTitle: "Member Group's Created",
    memberGroupCreatedDesc: "member group had been created",
    memberGroupDeletedTitle: "Member Group's Deleted",
    memberGroupDeletedDesc: "member group had been Deleted",
    memberGroupEditTitle: "Member Group's Details Changed",
    memberGroupEditDesc: "member group details had been modified",
    
  },
  es: {
    deviceUIDTitle: "ID del Dispositivo",
    deviceTitle: "Tipo de Dispositivo",
    timeTitle: "Hora",
    statusTitle: "Estado de Aprobación",
    tokenTitle: "Token de Solicitud",
    userEmailTitle: "Correo Electrónico",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    noDataTitle: "No hay datos para mostrar",
    refreshTitle: "Actualizar",
    deletedLock: "Candado Eliminado",
    changedPassword: "La contraseña de la cuenta ha sido cambiada",
    changedEmail: "El correo electrónico de la cuenta ha sido actualizado",
    deletedMessage: " Has eliminado el Candado: ",
    lockChangedPassword: "Actualización de la Contraseña del Candado",
    hasBeenDeleted: "ha sido eliminado",
    lockPasswordBeenChanged: " la contraseña ha sido cambiada",
    from: "Desde ",
    to: " a ",
    by: " by ",
    memberRemoveditle: "Miembro Eliminado",
    memberRemovedDescription: " ha sido eliminado con éxito.",
    memberGroupMemberAddTitle: "Member Group's Member Added",
    memberGroupMemberAddDesc: "Member(s) had been added to member group",
  },
});

class ActivityLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityLogsArray: [],
      logsListArray: [],
      showPopup: false,
      loading: false,
      initialLoading: true,
      expandedActivityKey: null,
      tableVersion: 0,
    };

    this.updateRequestLogs = this.updateRequestLogs.bind(this);
    this.renderApprovalBtn = this.renderApprovalBtn.bind(this);
    //  this.handleReadButton = this.handleReadButton.bind(this);
  }

  async componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    // put all Logs under current super admin into requestLogsArray
    await fire
      .database()
      .ref("individualActivities")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          let LogsArray = [];

          snapshot.forEach((Log) => {
            let Logval = Log.val();
            // console.log(`hi checking ${JSON.stringify(Logval)} + ${Logval.snapKey} + ${Logval.oldEmail}`)
            let requestLog;
            //  if(!Logval.isRead) {
            if (Logval.activityType === 5) {
              requestLog = {
                // isRead: Logval.isRead,
                Type: Logval.activityType,
                lockName: Logval.lockName,
                lockSerial: Logval.lockSerial,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 6) {
              requestLog = {
                // isRead: Logval.isRead,
                Type: Logval.activityType,
                lockName: Logval.lockName,
                lockSerial: Logval.lockSerial,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            }
            //type 7 = user changed password
            else if (Logval.activityType === 7) {
              requestLog = {
                // isRead: Logval.isRead,
                Type: Logval.activityType,
                userEmail: Logval.userEmail,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            }
            //type 8 = user changed email
            else if (Logval.activityType === 8) {
              requestLog = {
                Type: Logval.activityType,
                userEmail: Logval.userEmail,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
                newEmail: Logval.newEmail,
                oldEmail: Logval.oldEmail,
              };
            } else if (Logval.activityType === 9) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.memberEmail,
                memberName: Logval.memberName,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 10) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 11) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 12) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 13) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 14) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 19) {
              requestLog = {
                Type: Logval.activityType,
                tableDescription: Logval.description,
                detailedDescription: Logval.detailedDescription || "",
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else {
              requestLog = {
                //status false = unread; true = read;
                //  isRead: Logval.isRead,
                Type: Logval.activityType,
                lockName: Logval.lockName,
                lockSerial: Logval.lockSerial,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.created * 1000,
              };
            }
            // }
            LogsArray.push(requestLog);
          });

          this.setState({
            activityLogsArray: LogsArray,
          });

          // console.log(this.state.requestLogsArray);
        }
      });
    //mapping the data
    const activityListData = _.map(
      this.state.activityLogsArray,
      (accessData) => {
        const type = Number(accessData.Type);
        if (type === 5) {
          return {
            data: {
              type: type,
              lockName: accessData.lockName,
              lockSerial: accessData.lockSerial,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 6) {
          return {
            data: {
              type: type,
              lockName: accessData.lockName,
              lockSerial: accessData.lockSerial,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 7) {
          return {
            data: {
              type: type,
              userEmail: accessData.userEmail,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 8) {
          return {
            data: {
              type: type,
              userEmail: accessData.userEmail,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
              newEmail: accessData.newEmail,
              oldEmail: accessData.oldEmail,
            },
          };
        } else if (type === 9) {
          return {
            data: {
              type: type,
              memberEmail: accessData.memberEmail,
              memberName: accessData.memberName,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 10) {
          return {
            data: {
              type: type,
              memberEmail: accessData.memberEmail,
              memberName: accessData.memberName,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 11) {
          return {
            data: {
              type: type,
              memberEmail: accessData.memberEmail,
              memberName: accessData.memberName,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 12) {
          return {
            data: {
              type: type,
              memberEmail: accessData.memberEmail,
              memberName: accessData.memberName,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 13) {
          return {
            data: {
              type: type,
              memberEmail: accessData.memberEmail,
              memberName: accessData.memberName,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 14) {
          return {
            data: {
              type: type,
              memberEmail: accessData.memberEmail,
              memberName: accessData.memberName,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else if (type === 19) {
          return {
            data: {
              type: type,
              tableDescription: accessData.tableDescription,
              detailedDescription: accessData.detailedDescription || "",
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        } else {
          return {
            data: {
              type: type,
              lockName: accessData.lockName,
              lockSerial: accessData.lockSerial,
              tableDescription: accessData.tableDescription,
              key: accessData.key,
              uid: accessData.uid,
              time: accessData.time,
            },
          };
        }
      }
    );
    const logsListArray = [...activityListData].sort((a, b) =>
      a.data.time < b.data.time ? 1 : -1
    );

    this.setState({
      logsListArray: logsListArray,
      initialLoading: false,
    });
  }

  renderApprovalBtn(accessData) {
    return (
      <ApprovalBtn accessData={accessData} refresh={this.updateRequestLogs} />
    );
  }

  async updateRequestLogs() {
    this.setState({ loading: true });
    // put all Logs under current super admin into requestLogsArray
    await fire
      .database()
      .ref("individualActivities")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          let LogsArray = [];

          snapshot.forEach((Log) => {
            let Logval = Log.val();
            let requestLog;
            //  if(!Logval.isRead) {
            if (Logval.activityType === 5) {
              requestLog = {
                //  isRead: Logval.isRead,
                Type: Logval.activityType,
                lockName: Logval.lockName,
                lockSerial: Logval.lockSerial,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 6) {
              requestLog = {
                //  isRead: Logval.isRead,
                Type: Logval.activityType,
                lockName: Logval.lockName,
                lockSerial: Logval.lockSerial,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 7) {
              requestLog = {
                //  isRead: Logval.isRead,
                Type: Logval.activityType,
                userEmail: Logval.userEmail,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 8) {
              requestLog = {
                Type: Logval.activityType,
                userEmail: Logval.userEmail,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
                newEmail: Logval.newEmail,
                oldEmail: Logval.oldEmail,
              };
            } else if (Logval.activityType === 9) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.memberEmail,
                memberName: Logval.memberName,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 10) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 11) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 12) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 13) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 14) {
              requestLog = {
                Type: Logval.activityType,
                memberEmail: Logval.userEmail,
                tableDescription: Logval.description,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else if (Logval.activityType === 19) {
              requestLog = {
                Type: Logval.activityType,
                tableDescription: Logval.description,
                detailedDescription: Logval.detailedDescription || "",
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.timeStamp,
              };
            } else {
              requestLog = {
                //status false = unread; true = read;
                // isRead: Logval.isRead,
                Type: Logval.activityType,
                lockName: Logval.lockName,
                lockSerial: Logval.lockSerial,
                tableDescription: Logval.description,
                key: Logval.snapKey,
                uid: Logval.userUid,
                time: Logval.created * 1000,
              };
            }
            // }

            LogsArray.push(requestLog);
          });

          this.setState({
            activityLogsArray: LogsArray,
          });

          // console.log(this.state.requestLogsArray);
        } else {
          // If no data exists, set empty array
          this.setState({
            activityLogsArray: [],
          });
        }
      });

    // Wait for state to update before mapping
    setTimeout(() => {
      const activityListData = _.map(
        this.state.activityLogsArray,
        (accessData) => {
          const type = Number(accessData.Type);
          if (type === 5) {
            return {
              data: {
                type: type,
                lockName: accessData.lockName,
                lockSerial: accessData.lockSerial,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 6) {
            return {
              data: {
                type: type,
                lockName: accessData.lockName,
                lockSerial: accessData.lockSerial,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 7) {
            return {
              data: {
                type: type,
                userEmail: accessData.userEmail,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 8) {
            return {
              data: {
                type: type,
                userEmail: accessData.userEmail,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
                newEmail: accessData.newEmail,
                oldEmail: accessData.oldEmail,
              },
            };
          } else if (type === 9) {
            return {
              data: {
                type: type,
                memberEmail: accessData.memberEmail,
                memberName: accessData.memberName,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 10) {
            return {
              data: {
                type: type,
                memberEmail: accessData.memberEmail,
                memberName: accessData.memberName,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 11) {
            return {
              data: {
                type: type,
                memberEmail: accessData.memberEmail,
                memberName: accessData.memberName,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 12) {
            return {
              data: {
                type: type,
                memberEmail: accessData.memberEmail,
                memberName: accessData.memberName,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 13) {
            return {
              data: {
                type: type,
                memberEmail: accessData.memberEmail,
                memberName: accessData.memberName,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 14) {
            return {
              data: {
                type: type,
                memberEmail: accessData.memberEmail,
                memberName: accessData.memberName,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else if (type === 19) {
            return {
              data: {
                type: type,
                tableDescription: accessData.tableDescription,
                detailedDescription: accessData.detailedDescription || "",
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          } else {
            return {
              data: {
                type: type,
                lockName: accessData.lockName,
                lockSerial: accessData.lockSerial,
                tableDescription: accessData.tableDescription,
                key: accessData.key,
                uid: accessData.uid,
                time: accessData.time,
              },
            };
          }
        }
      );

      const logsListArray = [...activityListData].sort((a, b) =>
        a.data.time < b.data.time ? 1 : -1
      );

      this.setState({
        logsListArray: logsListArray,
        loading: false,
        expandedActivityKey: null,
        tableVersion: this.state.tableVersion + 1,
      });
    }, 100);
  }
  // async handleReadButton() {
  //   await fire
  //     .database()
  //     .ref("individualActivities")
  //     .child(auth.currentUser.uid)
  //     .once("value")
  //     .then(snapshot => {
  //       if(snapshot.exists) {
  //         snapshot.forEach(snap => {
  //           // console.log("snap key: " + snap.key)

  //           fire
  //             .database()
  //             .ref("individualActivities")
  //             .child(auth.currentUser.uid)
  //             .child(snap.key)
  //             .update({
  //               isRead: true,
  //             });
  //         })
  //       }
  //     })

  //   // after update read status, update the displayed table
  //   this.updateRequestLogs();
  // }

  dateTimeFormat(data) {
    let time = data.time;

    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time / 1000} format="full" includeDay />;
    }
  }

  columnStyleFormat(data, row, rowIdx, colIdx) {
    // if(!data.isRead){
    //   return {
    //     backgroundColor: '#D6EBFF'
    //   }
    // }else {
    return {
      backgroundColor: "transparent",
    };
    // }
  }
  iconTypeFormat(data) {
    let type = data.type;

    var styling = {
      width: "70px",
      height: "70px",
    };

    if (type === 0) {
      // return <img style={{width: "50px", height: "50px"}} src={accountManagement} alt="AuthorizeIMG" />;
      return (
        <img style={styling} src={accountManagement} alt="accountManagement" />
      );
    } else if (type === 5) {
      return <img style={styling} src={deleteLocks} alt="deleteLocks" />;
    } else if (type === 6) {
      return (
        <img
          style={styling}
          src={changeLockPasswords}
          alt="changeLockPassword5"
        />
      );
    } else if (type === 7) {
      return (
        <img
          style={styling}
          src={userPasswordChange}
          alt="userPasswordChange"
        />
      );
    } else if (type === 8) {
      return <img style={styling} src={SystemsUpdate} alt="updateEmail" />;
    } else if (type === 9) {
      return (
        <img style={styling} src={memberRemovedIcon} alt="memberRemoved" />
      );
    } else if (type === 10) {
      return (
        <img style={styling} src={memberGroupMemberAddedIcon} alt="memberGroupMemberAdded" />
      );
    } else if (type === 11) {
      return (
        <img style={styling} src={memberGroupCreatedIcon} alt="memberGroupCreated" />
      );
    } else if (type === 12) {
      return (
        <img style={styling} src={memberGroupDeletedIcon} alt="memberGroupDeleted" />
      );
    } else if (type === 13) {
      return (
        <img style={styling} src={memberGroupEditedIcon} alt="memberGroupEdited" />
      );
    } else if (type === 14) {
      return (
        <img style={styling} src={memberGroupMemberRemovedIcon} alt="memberGroupMemberRemoved" />
      );
    } else if (type === 19) {
      return (
        <img style={styling} src={memberBulkRemovedIcon} alt="blukMemberRemoved" />
      );
    } else {
      return <img style={styling} src={unknownStatus} alt="unknownStatus" />;
    }

    return <span>Unspecified type</span>;
  }

  descriptionFormat = (data) => {
    const { expandedActivityKey } = this.state;
    const isExpanded = expandedActivityKey === data.key;
    const styling = {
      width: "200px",
      margin: "0",
      padding: "0",
      fontWeight: "normal",
    };
    if (data.type === 0) {
      // return <img style={{width: "50px", height: "50px"}} src={authorizeIMG} alt="AuthorizeIMG" />;
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.accountNotifType}
          </p>
          <span style={styling}>{data.tableDescription}</span>
        </span>
      );
    }
    // else if (data.type === 1){
    //   return <span style={{height: "50px"}}>
    //     <p style={{fontWeight: "bold", margin: "0", padding: "0"}}>{localizationStrings.lockNotifType}</p>
    //     <span style={styling}>{data.tableDescription}</span>
    //   </span>;
    // }
    else if (data.type === 5) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.deletedLock}
          </p>
          <span style={styling}>
            {data.tableDescription + localizationStrings.hasBeenDeleted}
          </span>
        </span>
      );
    } else if (data.type === 6) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.lockChangedPassword}
          </p>
          <span style={styling}>
            {data.tableDescription +
              localizationStrings.lockPasswordBeenChanged}
          </span>
        </span>
      );
    } else if (data.type === 7) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.changedPassword}
          </p>
          <span style={styling}>{data.tableDescription}</span>
        </span>
      );
    } else if (data.type === 8) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.changedEmail}
          </p>
          <span style={styling}>
            {localizationStrings.from +
              data.oldEmail +
              localizationStrings.to +
              data.newEmail}
          </span>
        </span>
      );
    } else if (data.type === 9) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberRemoveditle}
          </p>
          <span style={styling}>
            {data.memberName + localizationStrings.memberRemovedDescription}
          </span>
        </span>
      );
    } else if (data.type === 10) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberGroupMemberAddTitle}
          </p>
          <span style={styling}>
            {localizationStrings.memberGroupMemberAddDesc +
              " " +
              data.tableDescription +
              localizationStrings.by +
              data.memberEmail}
          </span>
        </span>
      );
    } else if (data.type === 11) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberGroupCreatedTitle}
          </p>
          <span style={styling}>
            {data.tableDescription +
              " " +
              localizationStrings.memberGroupCreatedDesc +
              localizationStrings.by +
              data.memberEmail}
          </span>
        </span>
      );
    } else if (data.type === 12) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberGroupDeletedTitle}
          </p>
          <span style={styling}>
            {data.tableDescription +
              " " +
              localizationStrings.memberGroupDeletedDesc +
              localizationStrings.by +
              data.memberEmail}
          </span>
        </span>
      );
    } else if (data.type === 13) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberGroupEditTitle}
          </p>
          <span style={styling}>
            {data.tableDescription +
              " " +
              localizationStrings.memberGroupEditDesc +
              localizationStrings.by +
              data.memberEmail}
          </span>
        </span>
      );
    } else if (data.type === 14) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberGroupMemberRemovedTitle}
          </p>
          <span style={styling}>
            {localizationStrings.memberGroupMemberRemovedDesc +
              " " +
              data.tableDescription +
              localizationStrings.by +
              data.memberEmail}
          </span>
        </span>
      );
    } else if (data.type === 19) {
      const isExpanded = this.state.expandedActivityKey === data.key;
      // Debug: print the whole data object

      const parsedMembers = (data.detailedDescription || "")
        .split(",")
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0);

      return (
        <span style={{ height: "auto", display: "block" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.memberBulkRemovedTitle ||
              "Members Removed (Bulk)"}
          </p>
          <span style={{ width: "200px", display: "block" }}>
            {data.tableDescription}
          </span>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation(); // prevent row click issues

              this.setState({
                expandedActivityKey: isExpanded ? null : data.key,
              });
            }}
            style={{
              fontSize: "12px",
              marginTop: "5px",
              padding: "2px 6px",
              backgroundColor: "#f0f0f0",
              border: "1px solid #ccc",
              cursor: "pointer",
              borderRadius: "4px",
            }}
          >
            {isExpanded
              ? localizationStrings.hideDetails || "Hide Details"
              : localizationStrings.showDetails || "Show Details"}
          </button>

          {isExpanded && parsedMembers.length > 0 && (
            <ul style={{ marginTop: "5px", paddingLeft: "16px" }}>
              {parsedMembers.map((entry, i) => (
                <li key={i}>{entry}</li>
              ))}
            </ul>
          )}
        </span>
      );
    } else {
      return <span>Unspecified type</span>;
    }
  };

  keyFormat(data) {
    return data.key;
  }

  statusFormat(data) {
    // if(!data.isRead) {
    //   return <img style={{height: "10px", width: "10px"}} src={notificationStatus} alt="notificationStatus" />;
    // } else {
    return;
    // }
  }

  statusStyleFormat(data) {
    let styling = {
      width: "200px",
      margin: "0",
      padding: "0",
      fontWeight: "normal",
      justifyContent: "center",
      textAlign: "center",
      verticalAlign: "center",
      margin: "auto",
      padding: "auto",
    };

    // if (!data.isRead) {
    //   styling = {
    //     width: "200px",
    //     margin: "0",
    //     padding: "0",
    //     fontWeight: "normal",
    //     justifyContent: "center",
    //     textAlign: "center",
    //     verticalAlign: "center",
    //     margin: "auto",
    //     padding: "auto",
    //     backgroundColor: "#D6EBFF"
    //   }
    // }
    return styling;
  }

  loadingData() {
    if (this.state.initialLoading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  // timeStampFormat(timeStamp) {
  // 	return (
  // 		<TimeStamp time={timeStamp / 1000} format="full" includeDay />
  // 	);
  // }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    const override = {
      display: "block",
      margin: "0 auto",
    };

    const logsListData = this.state.logsListArray;
    // Debug: print the data passed to the table

    const customTotal = (from, to, size) =>
      this.state.currentLanguage === "en" ? (
        <span
          className="react-bootstrap-table-pagination-total"
          style={{ float: "right" }}
        >
          {localizationStrings.resultTitle1}
          {from}
          {localizationStrings.resultTitle2}
          {to}
          {localizationStrings.resultTitle3}
          {size}
          {localizationStrings.resultTitle4}
        </span>
      ) : this.state.currentLanguage === "ja" ? (
        <span
          className="react-bootstrap-table-pagination-total"
          style={{ float: "right" }}
        >
          {localizationStrings.resultTitle1}
          {localizationStrings.resultTitle2}
          {size}
          {localizationStrings.resultTitle3}
          {to}
          {localizationStrings.resultTitle4}
        </span>
      ) : (
        ""
      );

    const options = {
      paginationSize: 10,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(),
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: logsListData.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };

    const descriptionHover = (cell, row, enumObject, rowIndex) => {
      return cell.desc;
    };
    if (!this.state.loading) {
      return (
        <div>
          <div style={{ height: "30px" }}></div>
          <div
            style={{
              display: "flex",
              margin: "auto",
              padding: "auto",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <button
              onClick={this.updateRequestLogs}
              className={"hoverRefreshBtn notifBtn"}
            >
              {localizationStrings.refreshTitle}
            </button>
          </div>
          <div style={{ height: "10px" }}></div>
          {/* Notification table codes */}
          <BootstrapTable
            key={this.state.tableVersion + "-" + this.state.expandedActivityKey}
            pagination={true}
            bordered={false}
            data={logsListData}
            // data={this.state.multiSharingArray}
            // selectRow={selectRowProp}
            // deleteRow
            noDataIndication={this.loadingData()}
            options={options}
          >
            {/* key */}
            <TableHeaderColumn dataField="data.key" isKey={true} hidden>
              Key
            </TableHeaderColumn>

            {/* read status */}
            <TableHeaderColumn
              dataField="data"
              width="30px"
              dataFormat={this.statusFormat}
              tdStyle={this.statusStyleFormat}
            ></TableHeaderColumn>

            {/* notif type */}
            <TableHeaderColumn
              dataField="data"
              width="100px"
              dataFormat={this.iconTypeFormat}
              tdStyle={this.columnStyleFormat}
            ></TableHeaderColumn>

            {/* description */}
            <TableHeaderColumn
              dataField="data"
              width="50%"
              columnTitle={descriptionHover}
              dataFormat={this.descriptionFormat}
              tdStyle={this.columnStyleFormat}
              // dataFormat={this.dateTimeFormat}
            ></TableHeaderColumn>

            {/* time */}
            <TableHeaderColumn
              width="50%"
              dataField="data"
              dataFormat={this.dateTimeFormat}
              tdStyle={{ ...this.columnStyleFormat, paddingRight: "80px" }}
              dataAlign="right"
            ></TableHeaderColumn>
          </BootstrapTable>
          <div style={{ height: "200px" }}></div>
        </div>
      );
    } else {
      return (
        <div style={{ marginTop: "20%" }}>
          <span className={"text-danger"}>{this.state.errorMessage}</span>
          <NotificationSystem ref="notificationSystem" style={style} />
          {/* <ClipLoader
            css={override}
            size={150}
            color={"#a9a9a9"}
            loading={this.state.loading}
          /> */}
          <div style={{ textAlign: "center" }}>
            <Loading />
          </div>
        </div>
      );
    }
  }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(ActivityLogs);
